// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Outline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M48 83.5c19.606 0 35.5-15.894 35.5-35.5S67.606 12.5 48 12.5 12.5 28.394 12.5 48 28.394 83.5 48 83.5Zm0 4C26.185 87.5 8.5 69.815 8.5 48S26.185 8.5 48 8.5 87.5 26.185 87.5 48 69.815 87.5 48 87.5Z"
			fill="#fff"
		/>
	</svg>
);
export default Outline;
